import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type MemberInformation, type MemberRankInformation, type PersonFilterRequest } from 'services'

export interface MemberFilterRequest extends PersonFilterRequest {
  'chamber[]'?: number[]
  majmin?: string
  state?: number
}

export interface MemberFilterResults {
  data: MemberInformation[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export interface MemberRankFilterResults {
  data: MemberRankInformation[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export async function memberListFilter (params: MemberFilterRequest): Promise<MemberFilterResults> {
  return await http.get('/api/v1/us/member/', {
    params
  }).then(value => value.data)
    .catch(reason => {
      return {
        data: [],
        page_number: 0,
        page_size: 0,
        total_items: 0,
        total_pages: 0
      }
    })
}

export async function getChamberRankings (chamberId: number, stateId?: number): Promise<MemberFilterResults> {
  const params: Record<string, number> = { chamber: chamberId }
  if (stateId != null) {
    params.state = stateId
  }

  return await http.get('/api/v1/us/ranking/', { params })
    .then(value => value.data)
    .catch(() => ({
      data: [],
      page_number: 0,
      page_size: 0,
      total_items: 0,
      total_pages: 0
    }))
}

export async function updateMembersRanking (
  members: MemberRankInformation[]
): Promise<HttpResponse<MemberRankInformation[]>> {
  const displayOrderById = members.reduce<Record<number, number>>(
    (acc, member, index) => ({ ...acc, [member.id]: index + 1 }),
    {}
  )

  return await handleHttpRequest(http.patch('/api/v1/us/ranking/', { idAndDisplayOrderMap: displayOrderById }))
}
